import React from 'react';
import {CurrencyValue} from 'Common/Format';
import {Header} from 'semantic-ui-react';

export default ({item}) =>
  !item ? null : (
    <div id="paymentCollectionTotals" style={{marginTop: 25}}>
      <div>
        <Header as="h5">Sub-total:</Header>
        <span className="total-value">
          <CurrencyValue
            value={
              item.estimateId
                ? item.approvedAmount - item.approvedTotalTax
                : item.totalAmount - item.totalTax
            }
          />
        </span>
      </div>
      <div>
        <Header as="h5">Tax:</Header>
        <span className="total-value">
          <CurrencyValue
            value={item.estimateId ? item.approvedTotalTax : item.totalTax}
          />
        </span>
      </div>
      {item.invoiceId &&
        item.depositPaid && (
          <div>
            <Header as="h5">Deposit:</Header>
            <span className="total-value">
              -<CurrencyValue value={item.depositPaid || 0} />
            </span>
          </div>
        )}
      <div>
        <Header as="h5">Total:</Header>
        <span className="total-value">
          <CurrencyValue
            value={
              item.estimateId
                ? item.approvedAmount
                : (item.totalAmount || 0) - (item.depositPaid || 0)
            }
          />
        </span>
      </div>
      <div>
        <Header as="h5">Paid:</Header>
        <span className="total-value">
          <CurrencyValue
            value={
              item.invoiceId ? item.amountPaid || 0 : item.depositPaid || 0
            }
          />
        </span>
      </div>
      {item.estimateId && (
        <div>
          <Header as="h5">Deposit Due:</Header>
          <span className="total-value">
            <CurrencyValue value={item.depositDue || 0} />
          </span>
        </div>
      )}
      {item.invoiceId && (
        <div>
          <Header as="h5">Balance Due:</Header>
          <span className="total-value">
            <CurrencyValue value={item.balanceDue || 0} />
          </span>
        </div>
      )}
    </div>
  );



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/Totals.js